<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<vxe-grid ref="expressconfiglist" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="danger" content="清除" @click="clear"></vxe-button>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$switchs",
					"field": "combineparentchild",
					"title": "合并子母件",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$switchs",
					"field": "combinesplit",
					"title": "合并拆分件",
					"props": {
						"disabled":false
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": ["金额波动范围"]
				},
				{
					"type": "$inputNumber",
					"field": "floatamountvalue",
					"title": "数值",
					"props": {
						"disabled":false,
						"precision":2
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "floatamountpercent",
					"title": "百分比(%)",
					"props": {
						"disabled":false
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": ["重量波动范围"]
				},
				{
					"type": "$inputNumber",
					"field": "floatweightvalue",
					"title": "数值(kg)",
					"props": {
						"disabled":false,
						"precision":2
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "floatweightpercent",
					"title": "百分比(%)",
					"props": {
						"disabled":false
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				}

			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			row: {
				default: () => {
					return {}
				}
			},
			configjson: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				modal_title: '算法配置',
				modal_width:1000,
				modal_height:600,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 250
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'min',
						title: '最小重量(kg)',
						editRender: {
							name: '$inputNumber',
							props: {
								precision:2
							},
							events: {
								
							}
						},
					},
					{
						field: 'begintime',
						title: '开始时间',
						editRender: {
							name: '$datePicker',
							props: {
								type:'date'
							},
							events: {
								
							}
						},
					},
					{
						field: 'endtime',
						title: '结束时间',
						editRender: {
							name: '$datePicker',
							props: {
								type:'date'
							},
							events: {
								
							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					min: [{
						required: true
					}],
					max: [{
						required: true
					},{
						validator({cellValue,row}){
							return new Promise((resolve,reject)=>{
								if(parseFloat(row.min) >= parseFloat(cellValue)){
									reject(new Error('最大重量必须大于最小重量'))
								}else{
									resolve()
								}
								
							})
						}
					}],
					avg: [{
						required: true
					},{
						validator({cellValue,row}){
							return new Promise((resolve,reject)=>{
								if( parseFloat(row.max) < parseFloat(cellValue) || parseFloat(row.min) > parseFloat(cellValue) ){
									reject(new Error('均值必须介于最小重量与最大重量之间'))
								}else{
									resolve()
								}
								
							})
						}
					}]
				}
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: []
					})
				})
			},
			modal_init(){
				if(!this.row.logisticsid){
					this.modal_title = '算法配置[全局]'
				}else{
					this.modal_title = '算法配置['+this.row.logisticsname+']'
				}
				this.sourceData = JSON.parse(JSON.stringify(this.configjson))
				//console.log(this.sourceData)
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData.main){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						if(item == 'combineparentchild' || item == 'combinesplit'){
							this.fApi.setValue(item, parseInt(this.sourceData.main[item]))
						}	
						if(item.startsWith('float')){
							this.fApi.setValue(item, parseFloat(this.sourceData.main[item]))
						}					
					})
				}
				if(this.sourceData.avg_detail){
					this.getgrid().reloadData(this.sourceData.avg_detail)
				}
			},
			getgrid(){
				return this.$refs.expressconfiglist
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			clear(){
				this.$emit('success', {
					data: null,
					logisticsid:this.row.logisticsid
				})
				this.modal_cancel()
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					
					this.getgrid().validate(true, (res) => {
						//console.log(res)
						if (!res) {
							let submitData = JSON.parse(JSON.stringify(formData))							
							this.submitDataFormater(submitData)
							let detail = this.getgrid().getTableData().tableData
							let data = {}
							data.main = submitData
							data.avg_detail = detail
							//console.log(data,123123)
							this.$emit('success', {
								data: JSON.stringify(data),
								logisticsid:this.row.logisticsid
							})
							this.modal_cancel()
							//console.log(data)
						} else {
							for (let i in res) {
								console.log(res[i][0].rule)
								let content = res[i][0].rule.$options.content
								let message = res[i][0].rule.$options.message
								if(content){
									this.$message.error(content)
								}else if(message){
									this.$message.error(message)
								}else{
									this.$message.error('缺少必填项：' + res[i][0].column.title)
								}
								
							}
						}
					})
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>